export default __webpack_public_path__ + "static/oliverPatting-1251cb3b3042a6dd1cfa073faa9f495b.png";